// 设备购买 变更为 海外咨询
import React, { Component } from "react";
import { Form, Select, message, Icon } from "antd";
import { Modal, Button, Input } from '@ezviz/ezd';
import dclog from '../../common/utils/dclog';

import Cookies from 'js-cookie';
import moment from 'moment';
import "./index.less";
const { TextArea } = Input;

const FormItem = Form.Item;
// 日期格式;
const dateFormat = "YYYYMMDD";
// 产品弹窗版本号 v年月日;
const VERSION = "v20210720";

message.config({
  top: "40%"
});

class WrappedProbationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      autoModal: false,
      step: 0,
      modal: false,
      title: "海外项目咨询",
      appKey: "6666666666666666"
    };
  };

  hanelEmailChange(e) {
    const value = e.target.value;
    this.setState({
      email: value
    });
  };

  hanelEnterpriseChange(e) {
    const value = e.target.value;
    this.setState({
      enterprise: value
    });
  };

  componentWillMount() {

  };

  componentDidMount() {
    this.fetchAppInfo();

  }

  showModal = key => (e) => {
    e.preventDefault(); // 修复 Android 上点击穿透
    this.setState({
      title: "海外项目咨询",
      subTitle: '留下您的联系方式，我们会在24小时内联系您！',
      appKey: "6666666666666666",
      modal: true,
    });
    window.monitor && window.monitor.report({textKey: `website_fixbar_${this.props.ptype}`, text: this.props.title});
  };

  onClose = key => () => {
    const { step } = this.state;
    if (step == 0) {
      this.setState({
        modal: false,
      })
    } else {
      this.setState({
        step: 0,
      });
    }

  };

  addWork = (values) => {

    const { appKey } = this.state;
    const { simpleDescription = "售前咨询" } = this.props;
    const workListType = "H-3";

    let params = {};

    params.appKey = appKey;
    params.simpleDescription = simpleDescription;
    params.contactWay = values.contactWay;
    params.questionDescription = values.questionDescription;

    let extraOptionsAi = [];

    extraOptionsAi.push({
      key: "email",
      value: values.email,
      label: "邮箱"
    });
    extraOptionsAi.push({
      key: "enterprise",
      value: values.enterprise,
      label: "企业名"
    });
    extraOptionsAi.push({
      key: "name",
      value: values.name,
      label: "姓名"
    });
    Object.assign(params, { extraOptionsAi: JSON.stringify(extraOptionsAi) }, { workListType: workListType });

    const succes = data => {
      if (data.retcode === 0) {
        this.setState({
          step: 1,
        });
        message.destroy();
      } else {
        message.error("提交失败，请重试");
      }
    };
    const error = error => {
      console.log("创建工单失败e", error);
      message.error("提交失败，请重试");
    };
    values["appKey"] = appKey;
    console.log("values", values);
    fetch("/work/createByAdvisory", {
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify(params)
    })
      .then(response => response.json())
      .then((data) => {
        succes(data);
      })
      .catch((err) => {
        console.log(err);
        error(err)
      })
  };

  handleSubmit = e => {
    const { btnType } = this.props;
    const { appKey, autoModal } = this.state;
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let that = this;
        that.addWork(values);
      }
    });
  };

  ok = () => {
    this.setState({
      step: 0,
      modal: false,
      autoModal: false
    });
  };
  /*
  * 每个版本每日弹出一次；
  * 总计弹出三天后不再弹出；
  * 用户选择不再弹出，当前版本不再弹出；
  * 7月5日之后的注册用户
  */
  fetchAppInfo() {
    const success = (data) => {
      if (data && data.retcode === 0) {
        if (data.data.length !== 0) {
          const createTime = data.data[0].addTime;
          const currentRegTime = new Date(createTime).getTime();
          const newRegTime = new Date('2021-07-05 00:00:00').getTime();
          if (currentRegTime >= newRegTime) {
            this.showNoticeByDate()
          } else {
            return
          }
        }
      };
    }
    const error = (err) => {
      console.log("err", err);
    }
    let params = new FormData();
    params.append("start", 0);
    params.append("pageSize", 2);
    fetch(
      '/app/page',
      {
        method: 'POST',
        body: params
      }).then(response => response.json())
      .then(success)
      .catch((err) => {
        console.log(err);
        error(err)
      })
  }


  showNoticeByDate = () => {
    // 当前日期
    var date = moment().subtract(1, 'day').format(dateFormat);
    // 当前cookies记录
    const CONTACTFORDEVICE = (Cookies.get("contact_for_device") && Cookies.get("contact_for_device").length === 20) ? Cookies.get("contact_for_device") : `${VERSION}:${date}:0`;
    // 查询弹出记录次数
    const promotionNum = CONTACTFORDEVICE.split(":")[2] || 0;
    // 当前版本 && 总次数小于3 && 当日未弹出
    if (parseInt(promotionNum, 10) < 3 && (moment().format(dateFormat) !== CONTACTFORDEVICE.split(":")[1])) {
      this.showNotice((parseInt(promotionNum, 10) + 1));
    }
  }

  showNotice = (num) => {
    console.log("showNotice", num)
    this.setState({
      modal: true,
      autoModal: true
    })
    var date = moment().format(dateFormat);
    Cookies.set(
      "contact_for_device",
      `${VERSION}:${date}:${num}`,
      {
        path: "/",
        // 测试需要，临时设置1分钟
        expires: 360,//new Date(new Date().getTime() + 10 * 60 * 1000)
      });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { step, title, appKey } = this.state;
    const { props, width = 480, height = 648, } = this.props;
    return (
      <div className="ContactUsForDevice-wrap">
        {this.props.text ?
          <div className={this.props.className} onClick={this.showModal()}>{this.props.text}</div>
          :
          <div onClick={this.showModal()}>
            {this.props.children}
          </div>
        }
        <Modal
          closeIcon={
            <img src="https://resource.eziot.com/group2/M00/00/01/CtwQFl77BpmAfQsUAAACLpgJ95U706.png" style={{ width: 16 }} />
          }
          visible={this.state.modal}
          destroyOnClose
          transparent
          width={width}
          // bodyStyle={{ padding: 20 }}
          closable
          maskClosable={false}
          onCancel={this.onClose()}
          getContainer={this.props.parentNode}
          title={title}
          footer={step==1 ? null: <div style={{marginBottom: 24}}>
            <Button onClick={this.onClose()}>取消</Button>
            <Button type='primary' onClick={this.handleSubmit}>联系我们</Button>
          </div>}
          onClose={this.onClose()}
          afterClose={() => { }}
        >
          <div className="contact-us">
            {step === 0 &&
              <div className={`common-contact-us-form white mobile`}>
                {/* <div className="contact-us-form-title">{this.state.title}</div> */}
                <div className="contact-us-form-sub-title">{this.state.subTitle}</div>
                <Form className="work-form">
                  <FormItem label="姓名">
                    {getFieldDecorator("name", {
                      rules: [{ max: 20, message: "最多可输入20个字符" }]
                    })(
                        <Input placeholder="姓名" autoCapitalize={false} autoComplete={false} />
                    )}
                  </FormItem>
                  <FormItem label="公司名称">
                    {getFieldDecorator("enterprise", {
                      rules: [
                        { required: true, message: "请填写公司名称" },
                        { max: 20, message: "最多可输入20个字符" }
                      ]
                    })(
                        <Input placeholder="公司名称（必填）" autoCapitalize={false} autoComplete={false} />
                    )}
                  </FormItem>
                  <FormItem label="电话">
                    {getFieldDecorator("contactWay", {
                      rules: [
                        { required: true, message: "请填写电话" },
                        { max: 20, message: "最多可输入20个字符" },
                        { pattern: /^[0123456789-]+$/, message: "电话号码格式不正确" }
                      ]
                    })(
                          <Input
                            placeholder="电话（必填）"
                            autoCapitalize={false} autoComplete={false}
                          />
                    )}
                  </FormItem>
                  <FormItem label="邮箱">
                    {getFieldDecorator("email", {
                      rules: [
                        { max: 30, message: "最多可输入30个字符" },
                        { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/, message: "邮箱格式不正确" }
                      ]
                    })(
                        <Input id="key" placeholder="邮箱" autoCapitalize={false} autoComplete={false} />
                    )}
                  </FormItem>

                  <FormItem label="业务场景">
                    {getFieldDecorator("questionDescription", {
                      rules: [
                        { required: true, message: "请填写业务场景介绍" },
                        { max: 255, message: "最多可输入255个字符" }
                      ]
                    })(
                      <Input.TextArea placeholder="请填写业务场景介绍"
                        autoSize={{ minRows: 4, maxRows: 4 }}
                        autoCapitalize={false}
                        autoComplete={false}
                      />
                    )}
                  </FormItem>
                  {/* <div className="submit-btn-container">
                    <button className="submit-btn" onClick={this.handleSubmit}>联系我们</button>
                  </div> */}
                </Form>
              </div>
            }
            {step === 1 &&
              <div className={`submit-success ${this.props.theme}`}>
                <div className="success-img">
                  <img src="https://resource.eziot.com/group1/M00/00/00/CtwQE171lIGAKpDsAAAfG1DXt-I688.png" />
                </div>
                <div className="success-title">感谢留言</div>
                <div className="success-sub-title">我们会在24小时内联系您！</div>
                <div className="submit-btn-container">
                  <button className="submit-btn" onClick={() => this.ok()} style={{cursor:'pointer',}}>好的</button>
                </div>
              </div>
            }
          </div>
        </Modal>
      </div>

    );
  }
}

const ContactUsForDevice = Form.create()(WrappedProbationForm);

export default ContactUsForDevice;
